<template>
    <hm-content>
        <div class="flex flex-between">
            <el-radio-group
                size="small"
                v-model="timeStatus"
                @change="changegoodsStatus"
            >
                <el-radio-button
                        label="daipeihuo"
                >待配货</el-radio-button
                >
                <el-radio-button label="daifahuo"
                >待发货</el-radio-button
                >
                <el-radio-button label="yifahuo"
                >已发货</el-radio-button
                >
                <el-radio-button label="guaqi">已挂起</el-radio-button>
            </el-radio-group>
            <div>
                <el-input placeholder="请输入订单号/发货单号/提货码"  style="width: 250px;" clearable class="mr10" size="small" v-model="isDeliverSn"></el-input>
                <el-select v-model="shippers"  placeholder="请选择分销商" clearable class="mr10" size="small">
                    <el-option
                            v-for="(v,i) in selectShippers"
                            :label="v.storeName"
                            :value="v.storeCode"
                            :key="i"
                    ></el-option>
                </el-select>
                <el-button type="primary" @click="searchList" size="small">查询</el-button>
                <el-button
                    type="success"
                    size="small"
                    @click="output('queryAllList', '供货商代销发货列表')"
                    :loading="isOutputing"
                >导出</el-button
                >
            </div>
        </div>
        <div class="flex flex-between" style="margin: 25px 0">
            <div class="flex item-center">
                <el-radio-group
                        v-model="receiptsTemplate"
                        size="small"
                        @change="printTypeChange"
                >
                    <el-tooltip
                            effect="dark"
                            content="竖版发货单为小票模板"
                            placement="top"
                    >
                        <el-radio label="vertical">打印竖版发货单模板</el-radio>
                    </el-tooltip>
                    <el-tooltip
                            effect="dark"
                            content="横板发货单为A4模板"
                            placement="top"
                    >
                        <el-radio label="cross">打印横板发货单模板(A4)</el-radio>
                    </el-tooltip>
                </el-radio-group>
            </div>
            <div class="flex flex-end"  v-if="timeStatus == 'daipeihuo'">
                <p style="line-height: 50px; color: red;" class="mr20">如果系统配了快递云打印功能，点击去配货则同时打印发货单和快递单</p>
                <el-button type="text" icon="el-icon-printer" style="font-size: 18px;color: #0e1118;" @click="batchSetting" >批量打印发货单</el-button>
            </div>
            <div class="flex flex-end"  v-if="timeStatus == 'daifahuo' || timeStatus == 'guaqi' ">
                <el-button type="text" icon="el-icon-truck" style="font-size: 18px; color: #0e1118;" @click="batchDelivery">去发货</el-button>
            </div>
        </div>

        <div>
            <el-table
                    stripe
                    border
                    ref="table"
                    @selection-change="getChecked"
                    id="table"
                    size="small"
                    :key="Math.random()"
                :data="deliverGoodsTable"
            >
                <el-table-column
                        type="selection"
                        v-if="timeStatus === 'daipeihuo'"
                ></el-table-column>
                <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="55"
                    :index="index => index + (currentPages - 1) * pageSizes + 1"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="发货单号"
                    prop="deliverSn"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="订单号"
                        width="150"
                        prop="receiptSn"
                >
<!--                    <template slot-scope="scope">-->
<!--                        <el-button type="text"  @click="details(scope.row)">{{scope.row.receiptSn}}</el-button>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column
                        align="center"
                        label="配送方式"
                        prop="deliveryType"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.deliveryType == 'kdfh'" class="status blue">快递发货</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="分销商"
                        prop="shareStoreName"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="下单时间"
                        prop="purchaseTime"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="快递单号"
                        prop="expressOrderSn"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商品备注"
                        width="200px"
                        prop="remark"
                >
                    <template slot-scope="scope">
                        <el-input
                                @blur="remarkBlur(scope.row)"
                                @focus="remarkFocus(scope.row)"
                                style="height: 100%"
                                class="remark-tarea"
                                size="small"
                                type="textarea"
                                clearable
                                placeholder="请输入商品备注"
                                maxlength="128"
                                v-model="scope.row.remark"
                        ></el-input>
                        <!-- {{ scope.row.printNum }} -->
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="发货商品"
                        prop="goodsNames"
                        width="250"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="打印次数"
                        prop="printNum"
                >
                </el-table-column>
                <el-table-column
                        align="center"
                        label="收货人信息"
                        prop="receiverText"
                        width="250"
                >
                    <template slot-scope="scope">
                        <p style="text-align:left">收货人姓名：{{scope.row.receiverName}}</p>
                        <p style="text-align:left">收货人电话：{{scope.row.receiverMobile}}</p>
                        <p style="text-align:left">收货地址：{{scope.row.deliveryProvince}}{{scope.row.deliveryAddress}}</p>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                        align="center"-->
<!--                        label="是否拆单"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{scope.row.printNum > 1 ? '已拆单' : '未拆单'}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                        align="center"
                        label="当前状态"
                        v-if="timeStatus == 'yifahuo'"
                >
                    <template slot-scope="scope">
            <span
                    class="status blue"
                    v-if="scope.row.orderState === 'deliverOrder'">{{
                scope.row.deliveryType === "mdzt"
                  ? "等待门店自提"
                  : "等待确认收货"
              }}</span>
                        <span
                                class="status blue"
                                v-if="scope.row.orderState === 'takeOrder'">{{
                scope.row.deliveryType === "mdzt" ? "已提货" : "已确认收货"
              }}</span>
                        <span v-if="scope.row.orderState === 'returnOrder'" class="status blue">已退款</span>
                        <span v-if="scope.row.orderState === 'payOrder'" class="status blue">已发货</span>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="timeStatus != 'yifahuo'"
                        align="center"
                        label="操作"
                >
                    <template slot-scope="scope">
                        <el-button type="text" v-if="timeStatus == 'guaqi' || timeStatus != '待发货'" @click="reprint(scope.row)" class="status blue">补打发货单</el-button>
                        <el-button type="text" v-if="timeStatus != 'guaqi'" @click="hang(scope.row)" class="status blue">挂起</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="totals"
                        @current-change="paging"
                        @size-change="handleSizeChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPages"
                ></el-pagination>
            </div>
        </div>
        <!-- 订单详情 -->
        <el-dialog
                :close-on-click-modal="false"
                width="1200px"
                :visible.sync="dialogOrderDetails"
        >
            <div slot="title">
                <span class="mr10">订单详情</span>
            </div>
            <div class="content">
                <ul class="info-list">
                    <li class="mb20">
                        <div class="title">基本信息</div>
                        <div class="mb20">
                            <el-table stripe border :data="[detailsOrder.order]" size="small">
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="receiptSn"
                                        label="订单号"
                                ></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="spuName"
                                        label="发货单流水号"
                                ></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="memberMobile"
                                        label="会员手机号"
                                ></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="payMode"
                                        label="支付方式"
                                >
                                    <template slot-scope="scope">
                    <span
                            class="status danger"
                            v-if="scope.row.payMode === 'no_pay'"
                    >未支付</span
                    >
                                        <span
                                                class="status danger"
                                                v-if="scope.row.payMode === '0_pay'"
                                        >0元订单</span
                                        >
                                        <span
                                                class="status danger"
                                                v-if="scope.row.payMode === 'wx_pay'"
                                        >微信支付</span
                                        >
                                        <span
                                                class="status danger"
                                                v-if="scope.row.payMode === 'ali_pay'"
                                        >支付支付</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="orderSource"
                                        label="订单来源"
                                >
                                    <template slot-scope="scope">
                    <span v-if="scope.row.orderSource === 'wxShop'"
                    >微店订单</span
                    >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="orderType"
                                        label="订单类型"
                                >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                                        <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                                        <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                                        <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                                        <span v-if="scope.row.orderType === 'smg_faceToFace'"
                                        >代客下单-当面收款</span
                                        >
                                        <span v-if="scope.row.orderType === 'smg_netPush'"
                                        >代客下单-网络推送</span
                                        >
                                        <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                                        <span v-if="scope.row.orderType === 'integral_order'"
                                        >积分兑换订单</span
                                        >
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="mb20">
                            <el-table stripe border :data="[detailsOrder.order]" size="small">
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="deliveryType"
                                        label="配送方式"
                                >
                                    <template slot-scope="scope">
                    <span v-if="scope.row.deliveryType === 'mdzt'"
                    >门店自提</span
                    >
                                        <span v-if="scope.row.deliveryType === 'kdfh'"
                                        >快递发货</span
                                        >
                                        <span v-if="scope.row.deliveryType === 'tcps'"
                                        >同城配送</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        v-if="detailsOrder.order.deliveryType === 'mdzt'"
                                        header-align="center"
                                        align="center"
                                        prop="billNo"
                                        label="提货单号"
                                ></el-table-column>
                                <el-table-column
                                        v-else
                                        header-align="center"
                                        align="center"
                                        prop="expressOrderSn"
                                        label="物流单号"
                                ></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="spuName"
                                        label="自动确认收货时间"
                                ></el-table-column>
                                <!-- <el-table-column
                                  header-align="center"
                                  align="center"
                                  prop="shopName"
                                  label="指定信息"
                                ></el-table-column> -->
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="orderRemark"
                                        label="订单备注"
                                ></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        prop="spuName"
                                        label="活动信息"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </li>
                    <li class="mb20">
                        <div class="title">收货人信息</div>
                        <el-table stripe border :data="[detailsOrder.order]" size="small">
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="receiverName"
                                    label="收货人"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="receiverMobile"
                                    label="手机号码"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="spuName"
                                    label="邮政编码"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="deliveryAddress"
                                    label="收货地址"
                            >
                                <template slot-scope="scope">
                  <span
                  >{{ scope.row.deliveryProvince
                    }}{{ scope.row.deliveryAddress }}</span
                  >
                                </template>
                            </el-table-column>
                        </el-table>
                    </li>
                    <li class="mb20">
                        <div class="title">商品信息</div>
                        <el-table
                                border
                                :data="detailsOrder.orderGoods"
                                size="small"
                                :row-class-name="tableRowClassName"
                        >
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsImg"
                                    label="商品图片"
                            >
                                <template slot-scope="scope">
                                    <div>
                                        <div
                                                class="flex flex-center item-center"
                                                v-if="scope.row.returnType !== 'no'"
                                        >
                                            <!-- 仅退款 -->
                                            <img
                                                    v-if="scope.row.refundReturnType === 'money'"
                                                    style="width: 100px; height: 100px"
                                                    src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                                    alt=""
                                            />

                                            <!-- 退货退款 -->
                                            <img
                                                    v-if="scope.row.refundReturnType === 'refund'"
                                                    style="width: 100px; height: 100px"
                                                    src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                                                    alt=""
                                            />

                                            <!-- 退运费 -->
                                            <img
                                                    v-if="scope.row.refundReturnType === 'deliver'"
                                                    style="width: 100px; height: 100px"
                                                    src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                                                    alt=""
                                            />
                                        </div>
                                        <img
                                                class="warning-tuikuan"
                                                v-show="scope.row.returnType === 'yes'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                                alt=""
                                        />
                                        <img
                                                class="warning-tuikuan"
                                                v-show="scope.row.returnType === 'doing'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                                alt=""
                                        />

                                        <div
                                                class="flex flex-center item-center"
                                                :class="
                        scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                      "
                                        >
                                            <div>
                                                <img
                                                        style="width: 100px; height: 100px"
                                                        v-if="scope.row.goodsImg"
                                                        :src="scope.row.goodsImg"
                                                        alt=""
                                                />
                                                <div style="width: 100%">
                                                    <el-tag
                                                            style="width: 100%"
                                                            size="mini"
                                                            effect="plain"
                                                            type="success"
                                                            v-if="scope.row.isGift === 'gift'"
                                                    >赠 品</el-tag
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="spuName"
                                    label="商品名称/品牌"
                                    width="200"
                            >
                                <template slot-scope="scope">
                                    <p>{{ scope.row.spuName }}</p>
                                    <p>品牌: {{ scope.row.brandName }}</p>
                                    <el-tag
                                            style="width: 100%"
                                            size="mini"
                                            effect="plain"
                                            type="success"
                                            v-if="scope.row.isGift === 'gift'"
                                    >赠 品</el-tag
                                    >
                                    <el-tag type="warning"
                                    >{{
                                        scope.row.spuType === "virtual" ? "虚拟" : "实物"
                                        }}商品</el-tag
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="spuName"
                                    label="价格/货号"
                                    width="200"
                            >
                                <template slot-scope="scope">
                                    <p>价格: {{ scope.row.totalPrice }}</p>
                                    <p>货号: {{ scope.row.goodsSn }}</p>
                                    <p>条码: {{ scope.row.barCode }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="spuName"
                                    label="净重/毛重"
                            >
                                <template slot-scope="scope">
                                    <p v-if="scope.row.netWeight">
                                        净重: {{ scope.row.netWeight }}
                                    </p>
                                    <p v-if="scope.row.grossWeight">
                                        毛重: {{ scope.row.grossWeight }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="specIdGroupName"
                                    label="规格"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsNum"
                                    label="数量"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="totalPrice"
                                    label="小计"
                            >
                                <template slot-scope="scope">
                                    <p>
                                        {{ scope.row.totalPrice * scope.row.goodsNum }}
                                    </p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </li>
                    <li class="mb20">
                        <div class="title">费用信息</div>
                        <el-table stripe border :data="[detailsOrder.order]" size="small">
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="totalPrice"
                                    label="商品合计"
                            >
                                <template slot-scope="scope">
                                    <p>￥{{ scope.row.totalPrice }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="deliverMoney"
                                    label="运费"
                            >
                                <template slot-scope="scope">
                                    <p>￥{{ scope.row.deliverMoney }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="deliverCouponMoney"
                                    label="运费券抵扣"
                            >
                                <template slot-scope="scope">
                  <span class="status primary"
                  >-￥{{ scope.row.deliverCouponMoney }}</span
                  >
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="couponMoney"
                                    label="优惠券"
                                    width="220"
                            >
                                <template slot-scope="scope">
                                    <div
                                            class="primary"
                                            v-for="(v, i) in scope.row.orderCouponInfoModels"
                                            :key="i"
                                    >
                                        {{ v.ruleName }} {{ v.couponCode }}
                                    </div>
                                    <div class="status primary">
                                        -￥{{ scope.row.couponMoney }}
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                              header-align="center"
                              align="center"
                              prop="spuName"
                              label="积分抵扣"
                            >
                              --
                            </el-table-column> -->
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="activeMoney"
                                    label="积分抵扣"
                                    v-if="detailsOrder.order.orderType === 'integral_order'"
                            >
                                <template slot-scope="scope">
                  <span class="status danger"
                  >-￥{{ scope.row.activeMoney }}</span
                  >
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="activeMoney"
                                    label="活动优惠"
                                    v-else
                            >
                                <template slot-scope="scope">
                  <span class="status danger"
                  >-￥{{ scope.row.activeMoney }}</span
                  >
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="activeMoney"
                                    label="金豆"
                                    v-if="
                  detailsOrder.order.otherPayInfo &&
                    detailsOrder.order.otherPayInfo.length
                "
                            >
                                <template slot-scope="scope">
                                    <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                                        <div v-if="v.financeCode === 'goldBean'">
                                            金豆：已用{{ v.financeValue }}{{ v.relName }}抵用
                                            <span class="danger">-￥{{ v.currencyAmount }}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="actuallyPrice"
                                    label="实付金额"
                            >
                                <template slot-scope="scope">
                                    <div
                                            v-if="scope.row.orderType === 'integral_order'"
                                            class="status danger"
                                    >
                    <span v-if="scope.row.actuallyPrice"
                    >¥{{ scope.row.actuallyPrice }}+</span
                    >
                                        <span>{{ scope.row.integralPoint }}积分 </span>
                                    </div>
                                    <span v-else class="status danger"
                                    >¥{{ scope.row.actuallyPrice }}</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="payPrice"
                                    label="应付金额"
                            >
                                <template slot-scope="scope">
                                    <div
                                            v-if="scope.row.orderType === 'integral_order'"
                                            class="status danger"
                                    >
                    <span v-if="scope.row.payPrice"
                    >¥{{ scope.row.payPrice }}+</span
                    >
                                        <span>{{ scope.row.integralPoint }}积分 </span>
                                    </div>
                                    <span v-else class="status danger"
                                    >¥{{ scope.row.payPrice }}</span
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
                @click="dialogOrderDetails = false"
                size="small"
                type="primary"
        >关闭</el-button
        >
      </span>
        </el-dialog>
        <!--批量打印发货单详情-->
        <el-dialog
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                :width="receiptsTemplate === 'cross' ? '720px' : '240px'"
                :before-close="cancel"
                title="订单详情"
        >
            <div class="content">
                <div
                        class="flex flex-end"
                        style="padding-right: 20px; padding-top: 10px"
                >
                    <div>
                        <el-button type="primary" size="small" @click="printTe" id="btn"
                        >打印</el-button
                        >
                    </div>
                </div>
                <div ref="cross" v-if="receiptsTemplate === 'cross'">
                    <div
                            v-for="(newDetailsOrder, i) in orderPrintList"
                            :key="i"
                            style="page-break-after: always"
                    >
                        <ul class="info-lists" id="printTest">
                            <li class="mb10">
                                <div class="flex flex-between tit">
                                    <div class="flex-1 flex flex-warp">
                                        <div
                                                class="logoImg"
                                                style="width: 92px; height: 92px; paddingright: 20px"
                                        >
                                            <img
                                                    style="width: 100px; height: 100%"
                                                    :src="querySupplier.logoPath"
                                                    alt=""
                                            />
                                        </div>
                                        <div class="sh-info ml20">
                                            <div class="sh-name">
                                                {{ querySupplier.storeName }}
                                            </div>
                                            <div class="sh-xinxi">
                                                {{ querySupplier.storeAddress }}
                                            </div>
                                            <div class="sh-xinxi">
                                                电话：{{ querySupplier.contactPhone }}
                                            </div>
                                        </div>
                                    </div>
                                    <vue-barcode
                                            :value="newDetailsOrder.order.deliverSn"
                                            :options="barcode_option"
                                            tag="svg"
                                    ></vue-barcode>
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="consignee">
                                    <div style="fontweight: 700">
                                        流水号:{{ newDetailsOrder.order.serialNumber }}
                                    </div>
                                    <div
                                            style="fontweight: 700"
                                            v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                                    >
                                        配送方式:门店自提
                                    </div>
                                    <div
                                            style="fontweight: 700"
                                            v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                                    >
                                        配送方式:快递发货
                                    </div>
                                    <div
                                            style="fontweight: 700"
                                            v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                                    >
                                        配送方式:同城配送
                                    </div>
                                    <div>订单编号：{{ newDetailsOrder.order.receiptSn }}</div>

                                    <div style="fontweight: 600">收货人信息</div>
                                    <div>收货人：{{ newDetailsOrder.order.receiverName }}</div>
                                    <div>
                                        手机号码：{{ newDetailsOrder.order.receiverMobile }}
                                    </div>
                                    <div>邮政编码：{{ newDetailsOrder.order.spuName }}</div>
                                    <div>
                                        收货地址：{{ newDetailsOrder.order.deliveryProvince
                                        }}{{ newDetailsOrder.order.deliveryAddress }}
                                    </div>
                                </div>
                                <div class="consignee">
                                    <div>
                                        会员名称：{{ newDetailsOrder.order.memberName }}
                                        <span v-if="newDetailsOrder.order.nickName"
                                        >({{ newDetailsOrder.order.nickName }})</span
                                        >
                                    </div>
                                    <div>会员电话：{{ newDetailsOrder.order.memberMobile }}</div>
                                    <div>下单时间：{{ newDetailsOrder.order.purchaseTime }}</div>
                                    <div>支付时间：{{ newDetailsOrder.order.payTime }}</div>
                                    <div>
                                        支付方式：
                                        <span
                                                class="primary"
                                                v-if="newDetailsOrder.order.payMode === 'no_pay'"
                                        >未支付</span
                                        >
                                        <span
                                                class="primary"
                                                v-if="newDetailsOrder.order.payMode === '0_pay'"
                                        >0元订单</span
                                        >
                                        <span
                                                class="primary"
                                                v-if="newDetailsOrder.order.payMode === 'wx_pay'"
                                        >微信支付</span
                                        >
                                    </div>
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="modal-table">
                                    <div class="table-header flex">
                                        <div class="flex-3 flex flex-center">商品名称/品牌</div>
                                        <div class="flex-1 flex flex-center">价格/货号</div>
                                        <div class="flex-1 flex flex-center">活动</div>
                                        <div class="flex-1 flex flex-center">规格</div>
                                        <div class="flex flex-center" style="width: 30px">数量</div>
                                        <div class="flex-1 flex flex-center">小计</div>
                                    </div>
                                    <div
                                            class="table-body flex"
                                            :class="{ tuikuan: v.returnType !== 'no' }"
                                            v-for="(v, i) in newDetailsOrder.orderGoods"
                                            :key="i"
                                    >
                                        <img
                                                class="warning-tuikuan"
                                                v-show="v.returnType === 'yes'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                                alt=""
                                        />
                                        <img
                                                class="warning-tuikuan"
                                                v-show="v.returnType === 'doing'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                                alt=""
                                        />
                                        <div class="flex-3 flex flex-center flex-column">
                                            <div
                                                    class="flex flex-center item-center"
                                                    v-if="v.returnType !== 'no'"
                                                    style="
                          opacity: 0.3;
                          position: absolute;
                          left: 0;
                          top: 0;
                          bottom: 0;
                        "
                                            >
                                                <!-- 仅退款 -->
                                                <img
                                                        v-if="v.refundReturnType === 'money'"
                                                        style="width: 100px; height: 100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                                        alt=""
                                                />

                                                <!-- 退货退款 -->
                                                <img
                                                        v-if="v.refundReturnType === 'refund'"
                                                        style="width: 100px; height: 100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                                                        alt=""
                                                />

                                                <!-- 退运费 -->
                                                <img
                                                        v-if="v.refundReturnType === 'deliver'"
                                                        style="width: 100px; height: 100px"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                                                        alt=""
                                                />
                                            </div>
                                            <div>
                                                <p>{{ v.spuName }}</p>
                                                <p>品牌: {{ v.brandName }}</p>
                                                <el-tag type="warning"
                                                >{{
                                                    v.spuType === "virtual" ? "虚拟" : "实物"
                                                    }}商品</el-tag
                                                >
                                            </div>
                                        </div>
                                        <div class="flex-1 flex flex-center flex-column">
                                            <div>
                                                <p>价格: {{ v.totalPrice }}</p>
                                                <p>货号: {{ v.goodsSn }}</p>
                                                <p>条码: {{ v.barCode }}</p>
                                            </div>
                                        </div>
                                        <!-- <div class="flex-1 flex flex-center flex-column">
                                          <div>
                                            <p v-if="v.netWeight">净重: {{ v.netWeight }}</p>
                                            <p v-if="v.grossWeight">毛重: {{ v.grossWeight }}</p>
                                          </div>
                                        </div> -->
                                        <div class="flex-1 flex flex-center flex-column">
                                            {{ v.promotionInfo }}
                                        </div>
                                        <div class="flex-1 flex flex-center flex-column">
                                            {{ v.specIdGroupName }}
                                        </div>
                                        <div
                                                class="flex flex-center flex-column"
                                                style="width: 30px"
                                        >
                                            {{ v.goodsNum }}
                                        </div>
                                        <div class="flex-1 flex flex-center flex-column">
                                            {{ v.totalPrice * v.goodsNum }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-end" style="fontweight: 700">
                                    商品总数：{{ newDetailsOrder.orderGoodsNum }}
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="mt10 consignee" style="lineheight: 30px">
                                    备注：
                                    <span style="font-size: 30px">{{
                    newDetailsOrder.order.orderRemark
                  }}</span>
                                </div>
                            </li>
                            <li class="mb30 ml10">
                                <div class="mb20">
                                    制单人：_________ 配货人：_________ 验货人：_________
                                    收银员：_________
                                </div>
                                <div class="mb10">
                                    录单人：_________ 送货人：_________ 顾客：_________
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div ref="vertical" v-if="receiptsTemplate === 'vertical'">
                    <div
                            v-for="(newDetailsOrder, i) in orderPrintList"
                            :key="i"
                            style="page-break-after: always"
                            class="content"
                    >
                        <ul class="info-lists" ref="print" id="printTest">
                            <li>
                                <div class="flex flex-center">
                                    <vue-barcode
                                            :value="newDetailsOrder.order.deliverSn"
                                            :options="barcode_option"
                                            tag="svg"
                                    ></vue-barcode>
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="title">基本信息</div>

                                <div class="mb20">
                                    <div style="fontweight: 700" class="fz mb10">
                                        流水号:{{ newDetailsOrder.order.serialNumber }}
                                    </div>
                                    <div class="fz mb10">
                                        会员名称：{{ newDetailsOrder.order.memberName }}
                                        <span v-if="newDetailsOrder.order.nickName"
                                        >({{ newDetailsOrder.order.nickName }})</span
                                        >
                                    </div>
                                    <div class="fz mb10">
                                        会员电话：{{ newDetailsOrder.order.memberMobile }}
                                    </div>
                                    <div class="fz mb10">
                                        订单号：{{ newDetailsOrder.order.receiptSn }}
                                    </div>
                                    <div class="fz mb10">
                                        购物人：{{ newDetailsOrder.order.receiverName }}
                                    </div>
                                    <div class="fz mb10">
                                        收货人手机号：{{ newDetailsOrder.order.receiverMobile }}
                                    </div>
                                    <div
                                            class="fz mb10"
                                            v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                                    >
                                        配送方式：门店自提
                                    </div>
                                    <div
                                            class="fz mb10"
                                            v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                                    >
                                        配送方式：快递发货
                                    </div>
                                    <div
                                            class="fz mb10"
                                            v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                                    >
                                        配送方式：同城配送
                                    </div>

                                    <div class="fz mb10">
                                        付款时间：{{ newDetailsOrder.order.payTime }}
                                    </div>
                                    <div class="fz mb10">付款方式：微信支付</div>
                                    <div class="fz mb10">
                                        商城门店：{{ newDetailsOrder.order.shopName }}
                                    </div>
                                    <div class="fz mb10">
                                        收货地址：{{ newDetailsOrder.order.deliveryProvince
                                        }}{{ newDetailsOrder.order.deliveryAddress }}
                                    </div>
                                </div>
                            </li>
                            <li class="mb10">
                                <div class="title">商品信息</div>
                                <div
                                        class="fz mb30"
                                        v-for="(v, i) in newDetailsOrder.orderGoods"
                                        :class="{ wrongs: v.returnType !== 'no' }"
                                        :key="i"
                                >
                                    <div>
                                        <img
                                                v-show="v.returnType === 'yes'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                                alt=""
                                        />
                                        <img
                                                v-show="v.returnType === 'doing'"
                                                src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                                alt=""
                                        />
                                    </div>
                                    <div class="mb5">
                                        <p class="mb5">商品名称:{{ v.spuName }}</p>
                                    </div>
                                    <p class="mb5">活动:{{ v.promotionInfo }}</p>
                                    <p class="mb5">品牌:{{ v.brandName }}</p>
                                    <p class="mb5">规格:{{ v.specIdGroupName }}</p>
                                    <p class="mb5">条码: {{ v.barCode }}</p>
                                    <p class="mb5">数量:{{ v.goodsNum }}</p>
                                    <p class="mb5">原价:{{ v.totalPrice }}</p>
                                    <p class="mb5">实付:{{ v.payPrice }}</p>
                                </div>
                                <div class="fz mb10" style="fontweight: 700">
                                    商品总数：{{ newDetailsOrder.orderGoodsNum }}
                                </div>
                                <hr />
                                <div class="fz mb20">
                                    配送费：{{ newDetailsOrder.order.deliverMoney }}
                                </div>
                                <div class="fz mb20">
                                    优惠券：{{ newDetailsOrder.order.couponMoney }}
                                </div>
                                <div class="fz" style="height: 30px">
                                    合计：{{ newDetailsOrder.order.payPrice }}
                                </div>
                            </li>
                            <li v-if="newDetailsOrder.order.orderRemark">
                                <div class="title">备注</div>
                                <div style="font-size: 20px">
                                    备注：{{ newDetailsOrder.order.orderRemark }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer flex flex-center">
              <el-button @click="close" size="small" type="primary">关闭</el-button>
            </span> -->
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :visible.sync="dialogVisibleShipping"
                :title="titleOrder"
                :before-close="cancel"
        >
            <div v-if="shippingType === 'assigned'">
                <el-select
                        size="small"
                        filterable
                        class="mb20"
                        v-model="appointShopId"
                        placeholder="请选择需要指派发货的门店"
                >
                    <el-option
                            v-for="(item, i) in expressShopList"
                            :key="i"
                            :label="item.shopName"
                            :value="item.shopId"
                    >
                    </el-option>
                </el-select>
                <div class="form-item-tip">
                    指派前请线下与对方门店沟通清除，确认无误后再指派。
                </div>
            </div>
            <div v-if="shippingType === 'hang'">
                <div class="flex flex-center">
          <span
                  class="hmicon icon-tishi"
                  style="font-size: 50px; color: rgb(243, 174, 64)"
          ></span>
                </div>
                <div
                        class="flex flex-center mt10"
                        style="font-weight: 700; color: #222222; font-size: 16px"
                >
                    挂起提醒
                </div>
                <div class="flex flex-center mt10">
                    检测到该订单存在第三方发货商品，请确认是否一并挂起第三方发货商品
                </div>
            </div>
            <div v-if="shippingType === 'batchDelivery'">
                <el-image
                        class="mb10"
                        src="https://imgcdn.hemiao100.com/ThemePictures/fahuotip.png"
                ></el-image>
                <div style="padding: 0 20px" class="mt10">
                    <div class="flex flex-center mb20" style="font-size: 20px">
                        请使用扫码枪扫描发货单号/提货码
                    </div>
                    <div class="flex flex-between mb20">
                        <div style="font-size: 18px">需发货数量:{{ noNum }}</div>
                        <div style="font-size: 18px">已扫描发货:{{ yesNum }}</div>
                    </div>
                    <div style="font-size: 18px">
                        发货扫描:
                        <el-input
                                clearable
                                v-model="isDeliverSn"
                                size="small"
                                ref="deliverSn"
                                class="ipt mr10"
                                style="width: 250px"
                                placeholder="请扫描/输入发货单号/提货码"
                                @keyup.enter.native="submit()"
                        ></el-input>
                        <el-button
                                :disabled="isDeliverSn === ''"
                                type="primary"
                                size="small"
                                @click="submit"
                        >确认发货</el-button
                        >
                    </div>
                    <div class="primary mt10" style="marginleft: 81px">
                        手动输入请按确认发货按钮或回车键发货
                    </div>
                    <div class="table info-list mt10" v-if="shippedList.length">
                        <div class="title">已发货</div>

                        <el-table
                                stripe
                                border
                                :data="shippedList"
                                style="width: 100%"
                                size="small"
                        >
                            <el-table-column
                                    type="index"
                                    label="序号"
                                    header-align="center"
                                    align="center"
                            ></el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="deliverSn"
                                    label="发货单号"
                            >
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="receiptSn"
                                    label="订单号"
                            >
                                <template slot-scope="scope">
                                    <div class="blue pointer" @click="details(scope.row)">
                                        {{ scope.row.receiptSn }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="expressOrderSn"
                                    label="快递单号"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.expressOrderSn === ''">-</div>
                                    <div v-else>
                                        {{ scope.row.expressOrderSn }}
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    header-align="center"
                                    align="center"
                                    prop="goodsNames"
                                    label="发货商品"
                                    width="300"
                            >
                                <template slot-scope="scope">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <div v-html="scope.row.goodsNames"></div>
                                        </div>
                                        <div class="oneLine">{{ scope.row.goodsNames }}</div>
                                    </el-tooltip>
                                    <!-- {{ scope.row.goodsNames }} -->
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="flex flex-center mt20">
                        <el-button type="primary" size="small" @click="tingZhi"
                        >停止批量发货</el-button
                        >
                    </div>
                </div>
            </div>
            <span
                    slot="footer"
                    class="dialog-footer flex flex-center"
                    v-if="shippingType === 'hang'"
            >
        <el-button @click="allHang" size="small" type="primary"
        >全部挂起</el-button
        >
        <el-button @click="oneselfHang" size="small" type="info"
        >只挂起自发商品</el-button
        >
      </span>
            <span
                    slot="footer"
                    class="dialog-footer flex flex-center"
                    v-if="shippingType !== 'hang' && shippingType !== 'batchDelivery'"
            >
        <el-button @click="confirm" size="small" type="primary"
        >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :visible.sync="isKuaiDiDan"
                title="缺少快递单"
                width="40%"
        >
            <div style="padding: 0 20px">
                <div class="flex flex-center mb20" style="font-size: 20px">
                    该订单缺少快递单，请扫描或手输快递单后发货。
                </div>
                <!-- <div class="flex flex-between mb20">
                  <div style="fontSize:18px">需发货数量:{{ noNum }}</div>
                  <div style="fontSize:18px">已扫描发货:{{ yesNum }}</div>
                </div> -->
                <div style="font-size: 18px">
                    发货扫描:
                    <el-input
                            clearable
                            autofocus="autofocus"
                            v-model="expressOrderSn"
                            ref="express"
                            size="small"
                            class="ipt mr10"
                            style="width: 250px"
                            placeholder="请扫描/输入快递单号"
                            @keyup.enter.native="submitExpress()"
                    ></el-input>
                </div>
                <div class="primary mt10" style="margin-left: 81px">
                    扫描快递单后自动发货，手输快递单号后请按确认发货按钮完成发货。
                </div>
                <div class="flex flex-center mt20">
                    <el-button type="primary" size="small" @click="submitExpress"
                    >确认发货</el-button
                    >
                    <el-button size="small" @click="isKuaiDiDan = false">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </hm-content>
</template>

<script>
    import { getLoginUser } from "@/utils/auth";
    import { mapGetters } from "vuex";
    import {getCookie, setCookie} from "@/utils/utils";
    import moment from "moment";
    import XLSX from "xlsx";
    import VueBarcode from "@chenfengyuan/vue-barcode";
    import draggable from "vuedraggable";
    let wb; // 读取完成的数据
    let rABS = false; // 是否将文件读取为二进制字符串
export default {
    components: {
        VueBarcode,
        draggable
    },
    data(){
        return{
            expressOrderSn: "",
            isKuaiDiDan:false,
            noNum: 0,
            yesNum: 0,
            shippedList: [],
            isDeliverSn: "",
            expressShopList: [],
            appointShopId: "",
            shippingType: "",
            titleOrder: "",
            dialogVisibleShipping:false,
            barcode_option: {
                displayValue: true,
                height: "50px"
            },
            querySupplier: {},
            dialogVisible: false,//打印发货单窗口
            checkedRow: [],
            receiptsTemplate: "cross",
            dialogOrderDetails:false,
            timeStatus:'daipeihuo',   //发货状态
            shippers:'',       //发货商
            selectShippers:[],    //发货商列表
            deliverGoodsTable:[],
            total:0,
            currentPage:1,
            pageSize:10,
            totals:0,
            currentPages:1,
            pageSizes:10,
            searchCondition: {
                expressSendMode: "self",
                timeStatus: "",
                queryMobileType: "receiverMobile",
                querySnType: "receiptSn",
                querySnValue: "",
                queryMobileValue: "",
                applyDate: [],
                deliveryType: "",
                printNumType: "",
            },
            orderPrintList: [
                {
                    orderGoods: [],
                    order: {
                        deliverSn: ""
                    }
                }
            ],
            noDelivery: 0,
            noExpress: 0,
            isExpress: 0,
            guaqiNum: 0,
            list: [],
            isOutputing: false,
        }
    },
    computed: mapGetters(["detailsExpressOrder", "detailsOrder"]),
    created() {
        this.searchCondition.applyDate = [
            moment(new Date())
                .add(-30, "days")
                .format("YYYY-MM-DD") + " 00:00:00",
            moment(new Date()).format("YYYY-MM-DD") + " 23:59:59"
        ];

        this.getParamsCookie();
        if (this.$route.query.type) {
            this.searchCondition.timeStatus = this.$route.query.type;
        }
        this.queryAll()
    },
    mounted() {
        this.queryAllShopList();
        this.query_share_store_list();
    },
    methods:{
        //查询分销商
        async query_share_store_list(){
            const { result } = await this.$store.dispatch("share_store_list");
            console.log(result);
            this.selectShippers = result;

        },
        async queryKeywordOrderList() {
            const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
            // searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
            //     ? searchCondition.applyDate[0]
            //     : "";
            // searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
            //     ? searchCondition.applyDate[1]
            //     : "";
            Object.assign(searchCondition, {
                keyword: this.isDeliverSn
            });
            const { result } = await this.$store.dispatch(
                "findThirdExpressOrderPage",
                searchCondition
            );
            if (result.records.length) {
                let v = result.records[0];
                if (v.deliveryType === "kdfh" && !v.expressOrderSn) {
                    this.orderRow = v;
                    this.isKuaiDiDan = true;
                    this.$nextTick(() => {
                        this.$refs.express.focus();
                    });
                } else {
                    this.continueType = "queryKeywordOrderList";
                    this.continueOrder = [v];
                    let params = [v];
                    params[0].still = false;
                    this.$store
                        .dispatch("expressPut", params)
                        .then(res => {
                            if (res.code === "0") {
                                this.queryAll();
                                this.$message({
                                    message: "发货成功!",
                                    type: "success"
                                });
                                this.noNum = this.noNum - 1;
                                this.yesNum = this.yesNum + 1;
                                this.isDeliverSn = "";
                                this.queryList();
                                this.shippedList.unshift(v);
                                if (this.noNum === 0) {
                                    this.dialogVisibleShipping = false;
                                    this.searchCondition.timeStatus = "daifahuo";
                                    this.queryList();
                                    this.queryAll();
                                }
                            }
                        })
                        .catch(e => {
                            if (e.code === "-9999") {
                                this.errVisible = true;
                                this.errMsg = e.errMsg;
                            }

                            console.log("err: ", e);
                        });
                }
            } else {
                this.$message({
                    message: "发货失败,无匹配订单！",
                    type: "warning"
                });
            }
        },
        submit() {
            this.queryKeywordOrderList();
        },
        async queryAllShopList() {
            const { result } = await this.$store.dispatch("expressShopList");
            this.expressShopList = result;
        },
        batchDelivery() {   //去发货方法
            this.titleOrder = "批量发货";
            this.dialogVisibleShipping = true;
            this.shippedList = [];
            this.shippingType = "batchDelivery";
            this.$nextTick(() => {
                this.$refs.deliverSn.focus();
            });
            if (this.searchCondition.timeStatus === "daifahuo") {
                this.noNum = this.noExpress;
            } else {
                this.noNum = this.guaqiNum;
            }
        },
        details(row) {
            this.dialogOrderDetails = true;
            this.$store.dispatch("detailOrder", {
                orderId: row.orderId,
                expressQueryId: row.expressQueryId
            });
        },
        async queryAll(){
            let params = {
                pageSize:this.pageSizes,
                pageNo:this.currentPages,
                timeStatus:this.timeStatus,
                keyword:this.isDeliverSn,
                storeCode: this.shippers
            };
            const { result } = await this.$store.dispatch("findThirdExpressOrderPage",params);
            this.deliverGoodsTable = result.records;
            this.totals = result.total;
        },
        changegoodsStatus(){
            this.currentPage = 1;
            this.checkedRow = [];
            this.queryAll();
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
        },
        searchList(){
            this.pageSizes=10;
            this.currentPages=1;
            this.queryAll();
        },
        paging(page) {
            this.currentPages = page;
            this.queryAll();
        },
        handleSizeChange(size) {
            this.currentPages = 1;
            this.pageSizes = size;
            this.queryAll();
        },
        tableRowClassName({ row }) {
            if (row.returnType !== "no") {
                return "tuikuan";
            }
            return "";
        },
        //切换打印横版竖版发货单
        printTypeChange() {
            this.setParamsCookie();
        },
        setParamsCookie() {
            setCookie({
                key: "shippingOrderListParams",
                type: "session",
                data: Object.assign({}, this.searchCondition, {
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    receiptsTemplate: this.receiptsTemplate
                })
            });
        },
        getParamsCookie() {
            const prams = getCookie({
                key: "shippingOrderListParams",
                type: "session"
            });
            if (prams) {
                let search = {};

                for (let key in prams) {
                    if (
                        key !== "pageSize" &&
                        key !== "currentPage" &&
                        key !== "receiptsTemplate"
                    ) {
                        search[key] = prams[key];
                    }
                }
                // this.searchCondition = search;
                Object.assign(this.searchCondition, search);
                this.pageSize = prams.pageSize;
                this.currentPage = prams.currentPage;
                this.receiptsTemplate = prams.receiptsTemplate;
            }
        },
        getChecked(selection) {
            this.checkedRow = selection;
        },
        reprint(val){
            let arr = [];
            arr.push(val);
            this.checkedRow = arr;
            console.log("val:",arr)
            this.batchSetting();
        },
        //批量打印发货单方法
        async batchSetting() {
            console.log("this.checkedRow.length：",this.checkedRow.length);
            if (this.checkedRow.length) {
                this.printNumType = "batch";
                const { code, result } = await this.$store.dispatch(
                    "batchPrintOrderList",
                    this.checkedRow
                );
                if (code === "0") {
                    result.forEach(v => {
                        v.orderGoodsNum = 0;
                        v.orderGoods.forEach(j => {
                            v.orderGoodsNum += new Number(j.goodsNum);
                        });
                    });
                    this.dialogVisible = true;
                    this.orderPrintList = result;
                }
            } else {
                this.$message({
                    message: "请选择",
                    type: "warning"
                });
            }
            this.queryAll();
            this.queryList();
        },
        resetRuleForm() {
            setTimeout(() => {
                this.hangupMode = "this";
                this.row = {};
                this.appointShopId = "";
                this.breakList = [];
                this.noNum = 0;
                this.yesNum = 0;
                this.isDeliverSn = "";
                this.deliveryWay = "one";
            }, 0);
        },
        cancel() {
            this.dialogVisibleShipping = false;
            this.dialogDetails = false;
            this.dialogVisible = false;
            this.dialogVisibleOrder = false;
            this.dialogOrderDetails = false;
            this.resetRuleForm();
        },
        async querySuppliers(storeCode) {
            const { result } = await this.$store.dispatch("querySupplier", {
                storeCode
            });
            this.querySupplier = result;
        },
        async queryList() {
            // if (this.isArray(this.searchCondition.applyDate)) {
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
            // searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
            //     ? searchCondition.applyDate[0]
            //     : "";
            // searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
            //     ? searchCondition.applyDate[1]
            //     : "";

            Object.assign(params, searchCondition);
            this.setParamsCookie();
            const { result } = await this.$store.dispatch(
                "findThirdExpressOrderPage",
                params
            );
            const { records } = result;

            //this.guaqiNum = number.guaqiNum;
            this.list = records;
            this.list.forEach(v => {
                if (v.goodsNames.indexOf(",")) {
                    v.tooltipGoodsName = this.toBreak(v.goodsNames);
                } else {
                    v.tooltipGoodsName = [v.goodsNames];
                }
            });
            this.total = result.total;
            this.queryAll();
            if (this.total) {
                const { storeCode } = getLoginUser();
               // this.querySuppliers(this.list[0].storeCode);
                this.querySuppliers(storeCode);
            }

            return this.list;
            // } else {
            //   this.$message({
            //     message: "请选择下单时间段！",
            //     type: "warning"
            //   });
            // }
        },
        printTe() {
            console.log("this.checkedRow.length: ", this.checkedRow.length);
            document.getElementById("btn").blur();
            this.$print(this.$refs[this.receiptsTemplate]);
            if (this.checkedRow.length && this.printNumType != "printNum") {
                this.$store.dispatch("batchOrderRecord", this.checkedRow).then(res => {
                    console.log("res.code", res.code);
                    if (res.code == "0") {
                        this.queryList();
                        this.dialogVisible = false;
                        this.$store.dispatch("orderPrint", this.checkedRow).then(res => {
                            if (res.code === "0") {
                                // this.$message({
                                //   message: " 操作成功",
                                //   type: "success"
                                // });
                                this.queryList();
                                this.queryAll();
                            }
                        });
                    }
                });
            }

            if (this.printNumType === "printNum") {
                this.printNum();
            }
        },
        async printNum() {
            const { code } = await this.$store.dispatch("addExpressPrintNum", {
                expressQueryId: this.printNumRow.expressQueryId
            });
            if (code === "0") {
                this.queryList();
            }
        },
        toBreak(val) {
            return val.split(",").join("<br/>");
        },
        tingZhi() {
            this.dialogVisibleShipping = false;
            this.searchCondition.timeStatus = "daifahuo";
            this.resetRuleForm();
            this.queryList();
            this.queryAll();
        },
        allHang() {
            this.hangupMode = "all";
            this.editGuaQi();
        },
        confirm() {
            if (this.shippingType === "assigned") {
                if (this.appointShopId !== "") {
                    let params = {
                        expressQueryId: this.row.expressQueryId,
                        appointShopId: this.appointShopId
                    };
                    this.$store.dispatch("appointShop", params).then(res => {
                        if (res.code === "0") {
                            this.$message({
                                message: " 操作成功",
                                type: "success"
                            });
                            this.dialogVisibleShipping = false;
                            this.queryList();
                            this.queryAll();
                            this.resetRuleForm();
                        }
                    });
                } else {
                    this.$message({
                        message: "请选择指派门店",
                        type: "warning"
                    });
                }
            }
        },
        oneselfHang() {
            this.hangupMode = "this";
            this.editGuaQi();
        },
        async editGuaQi() {
            let params = {
                expressQueryId: this.row.expressQueryId,
                hangupState: this.row.hangupState,
                receiptSn: this.row.receiptSn,
                hangupMode: "this"
            };
            const { code } = await this.$store.dispatch(
                "editExpressOrderGuaqi",
                params
            );
            if (code === "0") {
                this.$message({
                    message: " 操作成功",
                    type: "success"
                });
                this.dialogVisibleShipping = false;
                this.queryList();
                this.queryAll();
                this.resetRuleForm();
            }
        },
        submitExpress() {
            if (this.expressOrderSn) {
                this.orderRow.expressOrderSn = this.expressOrderSn.trim();
                this.continueType = "submitExpress";
                this.continueOrder = [this.orderRow];
                let params = [this.orderRow];
                this.$store.dispatch("batchOrderRecord", params).then(res => {
                    if (res.code === "0") {
                        params[0].still = false;
                        this.$store
                            .dispatch("expressPut", params)
                            .then(res => {
                                if (res.code === "0") {
                                    this.$message({
                                        message: "发货成功!",
                                        type: "success"
                                    });
                                    this.isKuaiDiDan = false;
                                    this.$nextTick(() => {
                                        this.$refs.deliverSn.focus();
                                    });
                                    this.noNum = this.noNum - 1;
                                    this.yesNum = this.yesNum + 1;
                                    this.isDeliverSn = "";
                                    this.expressOrderSn = "";
                                    this.queryList();
                                    this.shippedList.unshift(this.orderRow);
                                    if (this.noNum === 0) {
                                        this.dialogVisibleShipping = false;
                                        this.searchCondition.timeStatus = "daifahuo";
                                        this.queryList();
                                        this.queryAll();
                                    }
                                }
                            })
                            .catch(e => {
                                if (e.code === "-9999") {
                                    this.errVisible = true;
                                    this.errMsg = e.errMsg;
                                }

                                console.log("err: ", e);
                            });
                    }
                });
            } else {
                this.$message({
                    message: "请填写快递单号！",
                    type: "warning"
                });
            }
        },
        hang(row) {
            this.titleOrder = "挂起";
            this.shippingType = "hang";
            this.row = row;
            this.guaQiVerify();
        },
        async guaQiVerify() {
            let params = {
                receiptSn: this.row.receiptSn,
                hangupMode: "this",
                hangupState: this.row.hangupState
            };
            const { code, result } = await this.$store.dispatch(
                "expressOrderGuaqiverify",
                params
            );
            if (code === "0") {
                if (result) {
                    this.editGuaQi();
                } else {
                    this.dialogVisibleShipping = true;
                }
            }
        },
        remarkFocus(row) {
            this.goodsRow = JSON.parse(JSON.stringify(row));
        },
        async remarkBlur(row) {
            // if (row.remark !== "" && row.remark !== null) {
            if (this.goodsRow.remark !== row.remark) {
                const { code } = await this.$store.dispatch("editGoodsRemark", row);
                if (code === "0") {
                    this.queryList();
                }
            }
            // }
        },
        async queryAllList() {            
            let params = {
                pageNo: 1,
                pageSize: 99999,
                timeStatus:this.timeStatus,
                keyword:this.isDeliverSn,
                storeCode: this.shippers
            };
            const { result } = await this.$store.dispatch(
                "findThirdExpressOrderPage",
                params
            );
            const { records } = result;
            return records;
        },
        // 导出excel
        output(funcName, title) {
            console.log('funcName:',funcName);
            console.log('title:',title);
            require.ensure([], () => {
                const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
                this.isOutputing = true;
                const func = this[funcName];
                console.log('func:',func);
                func()
                    .then(res => {
                    console.log("res:",res);    
                    const list = res;
                    list.forEach(v => {
                        if (v.deliveryType === "mdzt") {
                        v.deliveryType = "门店自提";
                        } else if (v.deliveryType === "kdfh") {
                        v.deliveryType = "快递发货";
                        } else if (v.deliveryType === "tcps") {
                        v.deliveryType = "同城配送";
                        }
                        v.receiverText = "收货人姓名：" + v.receiverName + ",收货人电话：" + v.receiverMobile + ",收货地址：" + v.deliveryProvince + v.deliveryAddress
                    });
                    console.log("list:",list);
                    const tHeader = this.$refs.table.columns
                        .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
                        .filter(o => o);
                    console.log("tHeader:",tHeader);
                    let filterVal = [];
                    if (list.length > 0) {
                        filterVal = this.$refs.table.$children
                            .map(o => o._props.prop)
                            .filter(o => o);
                    }
                    console.log("filterVal:",filterVal);
                    const data = this.formatJson(filterVal, list);
                    console.log("data:",data);
                    exportJsonToExcel(
                        tHeader,
                        data,
                        title + new Date().toLocaleString()
                    );
                    this.isOutputing = false;
                    })
                    .catch(() => {
                    this.isOutputing = false;
                    });
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]));
        },
    }
}
</script>
<style lang="scss">
    .page-x__scroll .el-scrollbar__wrap {
        overflow-y: hidden;
    }
</style>
<style lang="scss" scoped>
    .empty {
        width: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        .empty_tex {
            font-size: 18px;
            color: #666666;
            height: 40px;
            line-height: 40px;
            margin-bottom: 20px;
            padding: 0;
        }
    }
    .label-third {
        width: 120px;
        text-align: right;
        padding: 0 12px 0 0;
        box-sizing: border-box;
        font-weight: 700;
    }
    .suc {
        font-size: 17px;
        font-weight: bold;
    }
    .yuan {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: #2fc348;
        .icon-duigou {
            line-height: 100px;
            text-align: center;
            color: #fff;
        }
    }
    .errtip {
        font-size: 14px;
        color: #222222;
        font-weight: bold;
    }
    .only-tuikuan {
        opacity: 0.3;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
    .warning-tuikuan {
        position: absolute;
        left: 0;
        top: 0;
    }
    .left-triangle {
        width: 0;
        height: 0;
        border-bottom: 50px solid #e50065;
        border-right: 30px solid transparent;
    }
    .right-triangle {
        width: 0;
        height: 0;
        border-bottom: 50px solid #e50065;
        border-left: 30px solid transparent;
    }
    .bgc {
        background-color: #e50065;
    }
    .list-group {
        width: 200px;
        padding: 10px;
        // border: 1px solid #000;
        .list-group-item {
            padding: 10px;
            box-sizing: border-box;
            background-color: #fff;
            &:hover {
                transition: all 0.2s linear;
                background-color: #fddfeb !important;
                border-radius: 2px;
                color: rgb(226, 0, 93);
                .label {
                    color: rgb(226, 0, 93);
                }
            }
        }
        .preview-list-group-item {
            padding: 10px;
            &.active,
            &.active:hover {
                box-sizing: border-box;
                border: 2px solid #ea5798;
                cursor: move;
            }
            &:hover {
                box-sizing: border-box;
                border: 2px dashed #ea5798;
                cursor: move;
            }
            transition: all 0.2s linear;
            background-color: #fddfeb !important;
            border-radius: 2px;
            color: #e2005d;
            text-align: center;
        }
    }
    .delete {
        cursor: pointer;
        user-select: none;
    }
    .open-file {
        position: relative;
        overflow: hidden;
    }
    .open-file input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
    .tuikuan {
        background: rgba(255, 240, 240, 1);
        // border: 1px solid rgba(255, 0, 0, 1);
        position: relative;
        z-index: 9999999;
    }
    .oneLine {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .info-lists,
    .info-list {
        .title {
            color: rgba(34, 34, 34, 1);
            margin-bottom: 10px;
            &::before {
                display: inline-block;
                margin-right: 10px;
                content: "";
                width: 4px;
                height: 12px;
                background: #e50065;
                border-top-left-radius: 30px;
                border-bottom-right-radius: 30px;
            }
        }
    }
    .info-lists {
        // padding: 0 20px;
        .content {
            margin: -10px -20px -20px -20px;
        }
        .fz {
            font-size: 12px;
        }
        .mb5 {
            margin-bottom: 5px;
        }
        .tit {
            padding: 20px;
            border-bottom: 5px solid #000000;
        }
        .hr {
            width: 1px;
            height: 92px;
            background-color: #b7b7b7;
        }
        .logoImg {
            width: 92px;
            height: 92px;
            padding-right: 20px;

            img {
                width: 100px;
                height: 100px;
            }
        }
        .sh-info {
            padding-left: 10px;
            width: 230px;
            border-left: 2px solid #b7b7b7;
            .sh-name {
                font-size: 20px;
                font-weight: 600;
            }
            .sh-xinxi {
                line-height: 24px;
            }
        }
        .consignee {
            border-bottom: 2px solid #b7b7b7;
            padding: 20px 0;
            div {
                line-height: 24px;
            }
        }
    }
    .modal-table {
        border: 1px solid #ddd;
        border-radius: 5px;
        text-align: center;
        .table-header {
            background: #f7f7f7;
            font-weight: 700;
            font-size: 12px;
            > div {
                padding: 10px;
                color: #222;
            }
        }
        .table-body {
            > div {
                padding: 10px;
            }
        }
    }
</style>